import { API } from 'services';

export function createAdmin(params) {
  return API({
    method: 'POST',
    endpoint: '/superuser/admin',
    ...params,
  });
}

export function getAdmins(params) {
  const queryParams = new URLSearchParams(params).toString();

  return API({
    endpoint: `/superuser/admins?${queryParams}`,
  });
}

export function toggleCompanyStatus(companyId) {
  return API({
    method: 'POST',
    endpoint: `/superuser/company/${companyId}/toggle-status`,
  });
}


